@if (performance) {
  <div class="row-container">
    <div
      [style]="performance.scheduledToneelmeester ? '' : 'color: red; font-weight: bold'"
      class="datetime"
      >
      <!--      [ {{ performance.id }} ] &#45;&#45;-->
      <span class="date">{{ performance.datetime.split('T')[0] | logShowDate }}</span>
      <span class="om"> om </span>
      <span class="time">{{ performance.datetime | performanceAanvangTijd }}</span>
    </div>
    @if (performance?.show?.name) {
      <div class="show-name">
        {{ performance.show.name }}
      </div>
    }
    @if (performance?.scheduledToneelmeester !== null) {
      <div
        [style]="getToneelmeesterColor(performance.scheduledToneelmeester)"
        class="planned-toneelmeester"
        >
        {{ performance?.scheduledToneelmeester?.firstName || '-' }}
      </div>
    }
    @if (performance?.scheduledToneelmeester === null && performance?.suggestedScheduledToneelmeester !== null) {
      <div
        [style]="getSuggestedToneelmeesterColor(performance.suggestedScheduledToneelmeester)"
        class="heartbeat suggested-toneelmeester"
        >
        {{ performance?.suggestedScheduledToneelmeester?.firstName }}
      </div>
    }
    @if (performance?.scheduledToneelmeester === null && performance?.suggestedScheduledToneelmeester === null) {
      <div
        class="no-toneelmeester"
        >
        -
      </div>
    }
    <div class="toneelmeester-button-bar">
      @for (toneelmeester of toneelmeesters; track toneelmeester) {
        <ion-button
          (click)="emitClick(toneelmeester)"
          (keyup)="emitClick(toneelmeester)"
          [color]="getColor(toneelmeester, performance)"
          [disabled]="!allowEdit"
          [fill]="getFill(toneelmeester, performance)"
          class="toneelmeester-button"
          >
          {{ toneelmeester.firstName }}
        </ion-button>
      }
      <!--            <ng-container *ngIf="false">-->
      <!--                <ion-select-->
      <!--                        [(ngModel)]="performance.scheduledToneelmeester"-->
      <!--                        [interfaceOptions]="{ cssClass: 'action-sheet-eventslight' }"-->
      <!--                        class="external-toneelmeester-dropdown"-->
      <!--                        data-cy="select-stagemanager"-->
      <!--                        interface="action-sheet"-->
      <!--                        name="stagemanager"-->
      <!--                        placeholder="-"-->
      <!--                        required-->
      <!--                >-->
      <!--                    <ion-select-option [value]="null">-->
      <!--                        - -->
    <!--                    </ion-select-option>-->
    <!--                    <ion-select-option (change)="scheduleToneelmeester(performance, user)" *ngFor="let user of allUsers"-->
    <!--                                       [value]="user.id">-->
    <!--                        {{ user.firstName }} {{ user.lastName }}-->
  <!--                    </ion-select-option>-->
<!--                </ion-select>-->
<!--            </ng-container>-->
</div>
</div>
}
